<h1 mat-dialog-title>
  Summary Details
  <button mat-icon-button class="close-icon" (click)="onClose()">
    <mat-icon>close</mat-icon>
  </button>
</h1>

<div mat-dialog-content class="custom-dialog-content">
  <div class="table-container um-table-wrap">
  <table mat-table [dataSource]="dataSource" class="mat-table um-table">

    <!-- Parameter Column -->
    <ng-container matColumnDef="parameter">
      <th class="left-sorted-header" mat-header-cell *matHeaderCellDef>Parameter</th>
      <td class="left-sorted-header" mat-cell *matCellDef="let element">{{ element.parameter }}</td>
    </ng-container>

    <!-- Value Column -->
    <ng-container matColumnDef="value">
      <th class="centered-sorted-header" mat-header-cell *matHeaderCellDef>Value</th>
      <td class="centered-sorted-header" mat-cell *matCellDef="let element">{{ element.value }}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
  </div>
  <div style="margin-top: 20px; text-align: center;">
    <button mat-raised-button color="primary" (click)="navigateToDetailsPage()">
      <mat-icon>open_in_new</mat-icon>
      View Detailed Summary
    </button>
  </div>
</div>

